import Device from '../../../../../constants/deviceSizes';

export default {
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0 25px 0 36px',
    alignItems: 'center',
    height: '3rem',
    [Device.mobile]: {
      padding: 10
    }
  },
  description: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    textAlign: 'left'
  },
  icons: {
    width: 20,
    height: 20,
    marginRight: 10
  },
  iconAndTitleContainer: {
    display: 'flex',
    alignItems: 'center'
  }
};
